export default __webpack_public_path__ + "static/media/resume.8575701e.pdf";